const isUITest = (): boolean => Boolean(navigator.userAgent && navigator.userAgent.indexOf('UITests') >= 0);

export const isCustomTestUserAgent = (): boolean =>
    Boolean(navigator.userAgent && navigator.userAgent.indexOf('CustomUserAgent') >= 0);

export default isUITest;
